import React from 'react';
import { Offcanvas } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getLocalizedPath } from '../../../utils/localeRouting';

const Sidebar = ({ show, handleClose }) => {
   const { t, i18n } = useTranslation();
   const navigate = useNavigate();
   const Applications = <NavLink to="#">{t('headerTwo.applications')} </NavLink>
   const CosmeticHead = <NavLink to="#">{t('headerTwo.cosmeticDermatology')}</NavLink>;

   const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
   };

   return (
      <>

         <div >
            <Offcanvas show={show} onHide={handleClose} placement='end' className='side__bar'>
               <Offcanvas.Header closeButton>
                  {/* <Offcanvas.Title>Offcanvas</Offcanvas.Title> */}
               </Offcanvas.Header>
               <Offcanvas.Body>

                  <div style={{ marginBottom: "15px" }}>
                     <NavLink to={i18n.language === 'en' ? "/en/" : "/"}>{t('headerTwo.homePage')}</NavLink>
                  </div>

                  <div style={{ marginBottom: "15px" }}>
                     <NavLink to={i18n.language === 'en' ? "/en/resume" : "/ozgecmis"}>{t('headerTwo.resume')}</NavLink>
                  </div>

                  <Collapsible trigger={Applications} triggerTagName="div"
                     triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                     <ul className="sidebar_sub_menu text-white mt-3">
                        <li><NavLink to={i18n.language === 'en' ? "/en/applications/medical-applications" : "/uygulamalar/medikal-uygulamalar"}>{t('headerTwo.medicalDermatology')}</NavLink></li>
                        <li>
                           <Collapsible trigger={CosmeticHead} triggerTagName="div"
                              triggerOpenedClassName="icon_close" triggerClassName="iconAdd" open={false}>
                              <ul className="sidebar_sub_menu text-white mt-3">
                                 <li><NavLink to={i18n.language === 'en' ? "/en/applications/filler-applications" : "/uygulamalar/dolgu-uygulamalari"}>{t('headerTwo.fillingApplications')}</NavLink></li>
                                 <li><NavLink to={i18n.language === 'en' ? "/en/applications/thread-applications" : "/uygulamalar/iple-olan-uygulamalar"}>{t('headerTwo.faceLiftingApplications')}</NavLink></li>
                                 <li><NavLink to={i18n.language === 'en' ? "/en/applications/mesotherapy-applications" : "/uygulamalar/mezoterapi-uygulamalari"}>{t('headerTwo.mesotherapyApplications')}</NavLink></li>
                                 <li><NavLink to={i18n.language === 'en' ? "/en/applications/device-procedures" : "/uygulamalar/cihaz-islemleri"}>{t('headerTwo.deviceOperations')}</NavLink></li>
                              </ul>
                           </Collapsible>
                        </li>
                        <li><NavLink to={i18n.language === 'en' ? "/en/applications/healthy-living" : "/uygulamalar/saglikli-yasam"}>{t('headerTwo.healthyLiving')}</NavLink></li>
                     </ul>
                  </Collapsible>

                  <div style={{ marginBottom: "15px" }}>
                     <a href="https://blog.drebrukaragun.com" target="_blank" rel="noopener noreferrer">{t('headerTwo.blog')}</a>
                  </div>

                  <div style={{ marginBottom: "15px" }}>
                     <NavLink to={i18n.language === 'en' ? "/en/media" : "/medyada-biz"}>{t('headerTwo.weInTheMedia')}</NavLink>
                  </div>


                  <div style={{ marginBottom: "15px" }}>
                     <NavLink to={i18n.language === 'en' ? "/en/contact" : "/contact"}>{t('headerTwo.contact')}</NavLink>
                  </div>
                  <div>
                     <div className="header-lang pos-rel" style={{ padding: '16px 0px 0px 0px' }}>
                        <div className="lang-icon">
                           {i18n.language === 'en' ? <img src="/img/icon/lang.png" alt="" /> : <img src="/img/icon/turkey.png" alt="" />}
                           {i18n.language === 'tr' ? <span className='white-color'>TR<i className="fas fa-angle-down white-color"></i></span> :
                              <span className='white-color'>EN<i className="fas fa-angle-down white-color"></i></span>}
                        </div>
                        <ul className="header-lang-list" style={{ width: '60px', left: 0 }}>
                           {i18n.language === 'en' ? <li><a href="#lang-tr" onClick={(event) => {
                              event.preventDefault();
                              changeLanguage('tr');
                              navigate(getLocalizedPath(window.location.pathname, 'tr'));
                           }}>TR</a></li> : null}
                           {i18n.language === 'tr' ? <li><a href="#lang-en" onClick={(event) => {
                              event.preventDefault();
                              changeLanguage('en');
                              navigate(getLocalizedPath(window.location.pathname, 'en'));
                           }}>EN</a></li> : null}
                        </ul>
                     </div>
                  </div>

                  <div className="flex row" style={{ marginTop: "30px", gap: '20px' }}>
                     <a href="tel:+903125574646"> <span><i className="fas fa-phone"></i> +90 312 557 46 46</span></a>
                     <a href="tel:+905332691271"> <span><i className="fas fa-phone"></i> +90 533 269 12 71</span></a>
                  </div>

                  <div className='flex row' style={{ marginTop: "30px", gap: '20px' }} >
                     <h5><i className="fas fa-map-marker-alt" style={{ marginRight: '5px' }}></i> Beştepe Mahallesi 32.Cadde No:1/22 <br /> (Moment Beştepe Plaza) <br /> Ankara</h5>
                  </div>
               </Offcanvas.Body>
            </Offcanvas>
         </div>
      </>
   );
};

export default Sidebar;
